import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  Divider,
  Box
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isMore: boolean;
}

export const AssetDistributionModal: React.FC<Props> = ({ open, onClose, onConfirm, isMore }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "8px",
          width: "520px"
        }
      }}
    >
      <DialogTitle
        sx={{
          p: "16px 24px",
          color: "#071F35",
          fontSize: "18px"
        }}
      >
        <Box
          sx={{
            gap: "5px",
            color: "#0a3142",
            height: "54px",
            padding: "0",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end"
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography>Asset distribution</Typography>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Divider
            sx={{
              height: "1px",
              width: "100%",
              backgroundColor: "#dae0e2",
              borderColor: "#dae0e2",
              borderBottomWidth: "1px"
            }}
          />
        </Box>
      </DialogTitle>
      <DialogContent sx={{ p: "24px", color: "#496682" }}>
        {isMore ? (
          <Typography>The distribution of assets exceeds 100%. The existing assets will be divided proportionally.</Typography>
        ) : (
          <Typography>The distribution of assets does not reach 100%. The existing assets will be divided proportionally.</Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ p: "16px 24px", gap: "12px" }}>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onConfirm}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
